module.exports = __webpack_public_path__ + "static/complexity-scale-4dcc7253ab6033a995a8e51c34343d22.png";